import {React, _n} from 'pexui';
import * as utils from '../utilities/utils';
import globals from '../models/globals';
import {flow} from '../models/flow';
import initTheme from '../themes';
import {initTrack,track,trackError,setTrackOpts} from '../utilities/track';
import { DocUploadService } from '../services/docuploadsvc';

const Promise = utils.Promise;

export class InitPage extends React.Component {
    constructor(props) {
        super(props);
        this.messages = [];
        this.state = {
            messagesCount: 0
        }
    }

    componentDidMount(){
        // All widget initialization are moved here, to be clearer
        const widget = this.props.widget;
        const widgetConfig = widget.props.config;
        const widgetRequest = widget.props.req;
        const widgetCallback = widget.props.widgetCallback;
        // reset globals
        globals.config = {};
        globals.widgetConfig = widgetConfig;
        globals.BASE_URI = '';
        globals.htmlCache = {};
        globals.widgetSessionId = '';
        globals.widgetSessionSecret = '';
        globals.sentOnloadEvent = false;

        flow.widgetConfig = widgetConfig;
        flow.req = widgetRequest;
        flow.widgetCallback = widgetCallback;
        const {
            transaction_id,
            originator_id,
            market: country_code,
            document_data: documentData,
        } = flow.req;
        const { process_control_number } = documentData;
        try {
            initTrack(widgetConfig, widgetRequest);
            //Initialization tasks in parallel
            //Initialize themes
            const themesInitialization = initTheme(widgetConfig, widgetRequest);
            //Initialize the workflow (data model)
            const flowInitialization = flow.init(widget);

            const allTasks = Promise.all([
                themesInitialization,
                flowInitialization
            ]);

            allTasks.then(()=>{
                // The Nova flow skips all "landing" pages
                // and begins the Nova invocation immediately
                if (flow.isNovaOnly()) {
                    widget.nav("nova");
                } else {
                    // initialization is done, navigate to the IndexPage
                    widget.nav("index");
                }
            })
            .catch(promiseError => {
                const logData = {
                    transaction_id,
                    originator_id,
                    country_code,
                    process_control_number,
                    log_type: 'ERROR',
                    log_message: `Widget load exception: Failed to complete background processes: ${promiseError}`,
                };
                DocUploadService.log2Server(logData);
                track('Start:Error');
                const { message, errorKey } = utils.convertError(promiseError);
                trackError(errorKey);
                this.showError('Fail to initialize the documents: ' + message);
                flow.raiseInvokerEvent('fail', message);
            });
        } catch(loadError) {
            const logData = {
                transaction_id,
                originator_id,
                country_code,
                process_control_number,
                log_type: 'ERROR',
                log_message: `Widget load exception: ${loadError}`,
            };
            DocUploadService.log2Server(logData);
            track('Start:Error');
            const { message, errorKey } = utils.convertError(loadError);

            trackError(errorKey);
            this.showError('Fail to initialize: ' + message);
            flow.raiseInvokerEvent('fail', message);
        }
    }

    showError(err){
        if(err){
            const messages = this.messages;
            messages.push(err);
            this.setState({messagesCount: messages.length});
        }
    }

    render() {
        let hasErrors = false;
        const errors = this.messages.map(message=>{
            hasErrors = true;
            return <div className="infw-error">{''+message}</div>;
        });
        const iconStyle = hasErrors? {left:'50%'} : {left:'50%', 'margin-left':'-25px'};

        return <div className="infw-page px-widget">
               <div className="infw-message">Loading...</div>
               {errors}
               <div style={{width:'100%','margin-top': '20px'}}>
                    <div className={hasErrors?"dls-icon-warning-filled dls-accent-red-01":"progress-circle progress-indeterminate"}
                        style={iconStyle}/>
               </div>
            </div>;
    }
}



// WEBPACK FOOTER //
// ./application/src/views/init.jsx